<template>
  <div class="job-details">
    <router-link :to="{ name: 'DetailJob', params: {code: data.code } }" class="job-logo">
      <img :src="data.images" alt="">
    </router-link>
    <div class="job-description">
        <h4>{{ data.company }}</h4>
        <router-link :to="{ name: 'DetailJob', params: {code: data.slug } }">
            <h3>{{ data.title }}</h3>
        </router-link>
        <p class="job-text">{{ data.excerpt }}</p>
        <div class="job-tags">
            <a href="#" v-for="tag in data.tags.split(',')" :key="tag">{{ tag }}</a>
        </div>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'list_job',
        props: ['data']
    }
</script>
